import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';

const Context = React.createContext();
const { Consumer, Provider } = Context;

const PortalProvider = ({ children }) => {
  const [modalManagerRef, setModalManagerRef] = useState();

  const value = useMemo(
    () => ({
      modalManagerRef,
      setModalManagerRef,
    }),
    [modalManagerRef],
  );

  return <Provider value={value}>{children}</Provider>;
};

PortalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Consumer, Context, PortalProvider as Provider };
